import React, { FC } from 'react';

import useUser from 'hooks/useUser';

import ReviewerDashboard from './components/ReviewerDashboard/ReviewerDashboard';
import ProponentDashboard from './components/ProponentDashboard/ProponentDashboard';

export interface DashboardProps {}

const Dashboard: FC<DashboardProps> = () => {
  const { isReviewer } = useUser();

  return isReviewer ? <ReviewerDashboard /> : <ProponentDashboard />;
};

export default Dashboard;
